
(function(){
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s,c){ return (c||document).querySelector(s); }
  function $all(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }
  function money(n){ return '$' + n.toLocaleString('en-US'); }
  function pad(n){ return n < 10 ? '0'+n : ''+n; }

  /* CURSOR */
  (function cursor(){
    if(window.matchMedia('(hover: none)').matches || reduced) return;
    var dot = $('#cursorDot'), ring = $('#cursorRing');
    if(!dot || !ring) return;
    document.body.classList.add('has-cursor');
    var mx=0,my=0,rx=0,ry=0;
    document.addEventListener('mousemove', function(e){
      mx=e.clientX; my=e.clientY;
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';
    });
    (function loop(){
      rx += (mx-rx)*0.18; ry += (my-ry)*0.18;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
    document.addEventListener('mousedown', function(){ ring.classList.add('down'); });
    document.addEventListener('mouseup', function(){ ring.classList.remove('down'); });
    document.addEventListener('mouseover', function(e){ if(e.target.closest('[data-cursor], a, button, .card')) ring.classList.add('hover'); });
    document.addEventListener('mouseout', function(e){ if(e.target.closest('[data-cursor], a, button, .card')) ring.classList.remove('hover'); });
  })();

  /* PRELOADER */
  (function preloader(){
    var pre = $('#preloader'), counter = $('#preCounter'), bar = $('#preBar');
    var vault = $('#vault');

    /* has the seal already been broken this session? */
    var sealBroken = false;
    try { sealBroken = sessionStorage.getItem('savori_seal') === 'broken'; } catch(e){ sealBroken = false; }

    if(reduced || sealBroken){
      if(pre) pre.classList.add('done');
      if(vault) vault.classList.add('is-done');
      var marqueeEl = document.querySelector('.savori-marquee');
      if(marqueeEl) marqueeEl.classList.add('vault-cleared');
      document.documentElement.classList.remove('locked');
      document.body.classList.remove('locked');
      startReveals(); return;
    }
    document.documentElement.classList.add('locked');
    document.body.classList.add('locked');

    var n = 0;
    var step = function(){
      n += Math.floor(Math.random()*8) + 3;
      if(n >= 100) n = 100;
      if(counter) counter.textContent = n;
      if(bar) bar.style.width = n + '%';
      if(n < 100){ setTimeout(step, 70 + Math.random()*90); }
      else { setTimeout(function(){ if(pre) pre.classList.add('done'); }, 350); }
    };
    setTimeout(step, 200);

    var opened = false;
    function openVault(){
      if(opened) return; opened = true;
      try { sessionStorage.setItem('savori_seal', 'broken'); } catch(e){}
      var seam  = $('.vault-seam'), bloom = $('.vault-bloom');
      if(seam){ seam.style.animation='none'; seam.getBoundingClientRect(); seam.classList.add('is-fading'); }
      if(bloom){ bloom.style.animation='none'; bloom.getBoundingClientRect(); bloom.classList.add('is-fading'); }
      /* seal crack effect */
      var sealBtn = $('#vaultOpenBtn');
      if(sealBtn){ sealBtn.style.transform='scale(1.18)'; sealBtn.style.opacity='0'; sealBtn.style.transition='transform 0.5s var(--ease-out), opacity 0.4s'; }
      setTimeout(function(){ vault.classList.add('is-open'); }, 120);
      document.documentElement.classList.remove('locked');
      document.body.classList.remove('locked');
      startReveals();
      setTimeout(function(){ vault.classList.add('is-fading-out'); }, 1900);
      setTimeout(function(){
        vault.classList.add('is-done');
        var marqueeEl = document.querySelector('.savori-marquee');
        if(marqueeEl) marqueeEl.classList.add('vault-cleared');
      }, 2600);
    }

    /* wire the seal button */
    var sealBtn = $('#vaultOpenBtn');
    if(sealBtn){ sealBtn.addEventListener('click', openVault); }
    /* also allow clicking anywhere on the vault as fallback */
    if(vault){ vault.addEventListener('click', function(e){ if(!e.target.closest('#vaultOpenBtn')) return; openVault(); }); }
  })();

  /* HERO MOTES */
  (function motes(){
    if(reduced) return;
    var host = $('#heroMotes'); if(!host) return;
    var data = [
      {l:22,t:70,s:5,d:-0.2,b:1},{l:58,t:78,s:4,d:-2.1,b:1},
      {l:40,t:84,s:6,d:-3.8,b:1.5},{l:72,t:66,s:3,d:-2.9,b:1},
      {l:12,t:80,s:4,d:-1.2,b:1},{l:84,t:82,s:5,d:-5.0,b:1.5},
      {l:48,t:74,s:3,d:-6.4,b:1},{l:32,t:88,s:4,d:-4.5,b:1},
      {l:66,t:86,s:4,d:-7.2,b:1},{l:18,t:90,s:3,d:-8.1,b:0.8}
    ];
    data.forEach(function(m){
      var el = document.createElement('div'); el.className='mote';
      el.style.left=m.l+'%'; el.style.top=m.t+'%';
      el.style.width=m.s+'px'; el.style.height=m.s+'px';
      el.style.filter='blur('+m.b+'px)'; el.style.animationDelay=m.d+'s';
      host.appendChild(el);
    });
  })();

  /* GOLD FLAKES — falling embers around the logo */
  (function goldFlakes(){
    if(reduced) return;
    function spawn(hostId, count){
      var host = $('#'+hostId); if(!host) return;
      for(var i=0;i<count;i++){
        var el = document.createElement('div');
        el.className = 'tn-flake';
        var size = 3 + Math.random()*5;
        var left = Math.random()*100;
        var duration = 9 + Math.random()*10;
        var delay = Math.random()*-18;
        var drift = (Math.random()*80 - 40) + 'px';
        el.style.left = left + '%';
        el.style.width = size + 'px';
        el.style.height = size + 'px';
        el.style.setProperty('--flake-drift', drift);
        el.style.animationDuration = duration + 's';
        el.style.animationDelay = delay + 's';
        el.style.opacity = (0.4 + Math.random()*0.5);
        host.appendChild(el);
      }
    }
    spawn('thenameFlakes', 34);
  })();

  (function navScroll(){
    var nav=$('#hvNav'), lastY=0, ticking=false;
    function update(){
      var y=window.scrollY;
      if(y>60) nav.classList.add('scrolled'); else nav.classList.remove('scrolled');
      lastY=y; ticking=false;
    }
    window.addEventListener('scroll', function(){ if(!ticking){ requestAnimationFrame(update); ticking=true; } }, { passive:true });
  })();

  /* PROGRESS + BACK TO TOP */
  (function progress(){
    var bar=$('#progress'), totop=$('#toTop'), nav=$('#hvNav');
    function update(){
      var h=document.documentElement.scrollHeight-window.innerHeight; var p=h>0?(window.scrollY/h)*100:0; bar.style.width=p+'%';
      if(window.scrollY>900) totop.classList.add('show'); else totop.classList.remove('show');
      if(nav && bar){ bar.style.top = nav.getBoundingClientRect().height + 'px'; }
    }
    window.addEventListener('scroll', update, { passive:true });
    window.addEventListener('resize', update);
    totop.addEventListener('click', function(){ window.scrollTo({ top:0, behavior:'smooth' }); });
    update();
  })();

  /* REVEAL SYSTEM */
  var revealIO;
  function observeReveals(els){ if(!revealIO) return; els.forEach(function(el){ revealIO.observe(el); }); }
  function startReveals(){
    var all=$all('.reveal, .reveal-mask, .reveal-scale');
    if(!('IntersectionObserver' in window)){ all.forEach(function(el){ el.classList.add('in'); }); return; }
    revealIO=new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); revealIO.unobserve(e.target); } }); }, { threshold:0.14, rootMargin:'0px 0px -7% 0px' });
    all.forEach(function(el){ revealIO.observe(el); });
  }

  /* ACTIVE NAV SECTION */
  (function activeNav(){
    var links=$all('.nav-menu a[data-section]'), map={};
    links.forEach(function(l){ map[l.getAttribute('data-section')]=l; });
    var sections=['collection','mechanics','faq'].map(function(id){ return $('#'+id); }).filter(Boolean);
    if(!('IntersectionObserver' in window)) return;
    var io=new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ links.forEach(function(l){ l.classList.remove('active'); }); if(map[e.target.id]) map[e.target.id].classList.add('active'); } }); }, { threshold:0.4 });
    sections.forEach(function(s){ io.observe(s); });
  })();

  /* SMOOTH ANCHORS */
  (function anchors(){
    $all('[data-scroll-top]').forEach(function(a){
      a.addEventListener('click', function(e){ e.preventDefault(); window.scrollTo({ top:0, behavior:'smooth' }); });
    });
    $all('a[href^="#"]').forEach(function(a){
      if(a.hasAttribute('data-scroll-top')) return;
      a.addEventListener('click', function(e){
        var id=a.getAttribute('href'); if(id==='#'||id.length<2) return;
        var t=document.querySelector(id); if(!t) return;
        e.preventDefault(); window.scrollTo({ top:t.getBoundingClientRect().top+window.scrollY-70, behavior:'smooth' });
      });
    });
  })();

  /* FAQ */
  (function faq(){
    $all('.faq-item').forEach(function(item){
      var q=item.querySelector('.faq-q'), a=item.querySelector('.faq-a'); if(!q||!a) return;
      q.addEventListener('click', function(){
        var isOpen=item.classList.contains('open');
        $all('.faq-item').forEach(function(other){ if(other!==item){ other.classList.remove('open'); var oa=other.querySelector('.faq-a'); if(oa) oa.style.maxHeight=null; } });
        if(isOpen){ item.classList.remove('open'); a.style.maxHeight=null; }
        else { item.classList.add('open'); a.style.maxHeight=a.scrollHeight+40+'px'; }
      });
    });
  })();

  /* COUNTDOWN */
  (function countdown(){
    var DROP_DATE = null;
    var box=$('#countdown');
    var days=$('#cdDays'),hours=$('#cdHours'),mins=$('#cdMins'),secs=$('#cdSecs');
    if(!box) return;
    if(!DROP_DATE){
      box.innerHTML='<div class="cd-tba" style="display:flex;align-items:center;justify-content:center;gap:1.4rem;flex-wrap:wrap;"><span style="width:min(120px,16vw);height:1px;flex-shrink:0;background:linear-gradient(90deg,transparent,var(--gold-deep));display:block;"></span><span style="font-family:var(--serif);font-style:italic;font-weight:500;font-size:clamp(1rem,2.4vw,1.35rem);letter-spacing:0.04em;color:var(--gold-2);text-align:center;">The date is under seal. The list hears it first.</span><span style="width:min(120px,16vw);height:1px;flex-shrink:0;background:linear-gradient(270deg,transparent,var(--gold-deep));display:block;"></span></div>';
      return;
    }
    function tick(){ var diff=DROP_DATE-new Date(); if(diff<=0){ days.textContent='00'; hours.textContent='00'; mins.textContent='00'; secs.textContent='00'; return; } days.textContent=pad(Math.floor(diff/86400000)); hours.textContent=pad(Math.floor(diff%86400000/3600000)); mins.textContent=pad(Math.floor(diff%3600000/60000)); secs.textContent=pad(Math.floor(diff%60000/1000)); }
    tick(); setInterval(tick, 1000);
  })();

  /* HERO PARALLAX */
  (function parallax(){
    if(reduced||window.matchMedia('(hover: none)').matches) return;
    var hero=$('.hero'), glow=$('.hero-glow'), core=$('.hero-core'), inner=$('.hero-inner');
    if(!hero) return;
    hero.addEventListener('mousemove', function(e){ var r=hero.getBoundingClientRect(); var x=(e.clientX-r.left)/r.width-0.5, y=(e.clientY-r.top)/r.height-0.5; if(glow) glow.style.transform='translate(calc(-50% + '+(x*30)+'px), calc(-50% + '+(y*30)+'px))'; if(core) core.style.transform='translate(calc(-50% + '+(x*48)+'px), calc(-50% + '+(y*48)+'px))'; if(inner) inner.style.transform='translate('+(x*-10)+'px, '+(y*-10)+'px)'; });
    hero.addEventListener('mouseleave', function(){ if(glow) glow.style.transform=''; if(core) core.style.transform=''; if(inner) inner.style.transform=''; });
  })();

})();



(function(){
  'use strict';
  var fine=window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!fine||reduced) return;
  var magnets=Array.prototype.slice.call(document.querySelectorAll('.btn, .nav-access'));
  magnets.forEach(function(el){
    var strength=0.16; el.style.willChange='transform';
    el.addEventListener('mousemove', function(e){ var r=el.getBoundingClientRect(); var x=e.clientX-(r.left+r.width/2); var y=e.clientY-(r.top+r.height/2); el.style.transform='translate('+(x*strength)+'px,'+(y*strength)+'px)'; });
    el.addEventListener('mouseleave', function(){ el.style.transition='transform 0.55s cubic-bezier(0.22,1,0.36,1)'; el.style.transform=''; setTimeout(function(){ el.style.transition=''; },560); });
  });
  var grid=document.getElementById('grid'); if(!grid) return;
  grid.addEventListener('mousemove', function(e){ var card=e.target.closest('.card'); if(!card) return; var vis=card.querySelector('.card-visual'); if(!vis) return; var r=card.getBoundingClientRect(); var x=(e.clientX-r.left)/r.width-0.5; var y=(e.clientY-r.top)/r.height-0.5; vis.style.transform='rotateX('+(-y*5)+'deg) rotateY('+(x*6)+'deg)'; });
  grid.addEventListener('mouseout', function(e){ var card=e.target.closest('.card'); if(!card) return; if(card.contains(e.relatedTarget)) return; var vis=card.querySelector('.card-visual'); if(!vis) return; vis.style.transition='transform 0.8s cubic-bezier(0.22,1,0.36,1), box-shadow 0.7s cubic-bezier(0.22,1,0.36,1)'; vis.style.transform=''; setTimeout(function(){ vis.style.transition=''; },820); });
})();
